// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeQuickStartListBody = {
  leagueKey: string;
  cursor?: string | null;
  limit?: number | null;
};

export type typeQuickStartListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      quickStartId: string;
      leagueKey: string;
      title: string;
      displayOrder: number;
      config: {
        sportKey: string;
        leagueKey: string;
        contestType: "survivor";
        joinPolicy: "open" | "approval";
        memberSharingEnabled: boolean;
        contestSettings: {
          roundGrouping: "day" | "week";
          weekStartDay: number | null;
          roundLockTiming: "firstGame" | "lastGame";
          pickBasis: "moneyline" | "spread";
          spreadTiming: "lockedEarly" | "live" | null;
          advanceCriterion: "winAll" | "winHalfOrMore";
          livesAllowed: number;
          requiredPicksPerRound: number;
          maxEntriesPerMember: number;
          teamReuseAllowed: boolean;
          teamReuseLockoutDays: number | null;
          teamReuseMaxCount: number | null;
          skipsAllowed: boolean;
          skipsMaxPerContest: number | null;
          revivesAllowed: "unlimited" | "limited";
          revivesAllowedCount: number | null;
          postponementPolicy: "makeUpNextRound" | "countAsLoss";
          tiePolicy: "tieIsWin" | "tieIsLoss";
          tiebreaker: "splitMedal" | "noWinner" | "commissionerPick";
          winPoints: number;
          lossPoints: number;
        } | null;
      };
      summary: string;
    }[];
    nextCursor?: string | null;
  };
};

export type typeQuickStartListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeQuickStartListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeQuickStartListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaQuickStartListBody = {
  type: "object",
  properties: {
    leagueKey: { type: "string", maxLength: 3000, minLength: 1 },
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["leagueKey"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createQuickStartList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaQuickStartListBody);
  }

  return async function postQuickStartList(
    payload: typeQuickStartListBody,
  ): Promise<typeQuickStartListOutput200 | typeQuickStartListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postQuickStartList" failed before calling the network. #a07a55ac3ea6`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#a07a55ac3ea6" },
        },
        data: null,
      } as typeQuickStartListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/quick-start/list`,
      httpMethod: "POST",
      options,
    })) as typeQuickStartListOutput200 | typeQuickStartListOutput400;
  };
}
